<kort-samling>
  <!-- liste over invitasjoner -->
  @if(invitertTil().length > 0){
    <kort-samling-overskrift>{{ 'Dine invitasjoner'|translate }}</kort-samling-overskrift>
    <div class="grupper" data-testid="invitasjoner">
    @for (invitasjon of invitertTil(); track invitasjon.id) {
      <gruppe-invitasjon-kort [invitasjon]="invitasjon"/>
    }
    </div>
  }

  <!-- liste over aktive grupper -->
  @if(ordinaere().length > 0){
    <kort-samling-overskrift>{{ 'Dine grupper'|translate }}</kort-samling-overskrift>
    <div class="grupper" data-testid="ordinære-grupper">
      @for (gruppe of ordinaere(); track gruppe.id) {
        <gruppe-kort [gruppe]="gruppe"/>
      }
    </div>
  }

  <!-- liste over maler -->
  @if(maler().length > 0){
    <kort-samling-overskrift>{{ 'Gruppemaler'|translate }}</kort-samling-overskrift>
    <div class="grupper" data-testid="mal-grupper">
      @for (gruppe of maler(); track gruppe.id) {
        <gruppe-kort [gruppe]="gruppe"/>
      }
    </div>
  }

  <kort-samling-overskrift>{{ 'Ny Gruppe'|translate }}</kort-samling-overskrift>
  <gruppe-ny (vedOpprettet)="nyGruppeOpprettet($event)"/>

</kort-samling>
